/** 自定義元件 共同邏輯 */
export default {
  data() {
    return {
      dataValue: ''
    }
  },
  watch: {
    value: function(val) {
      this.dataValue = val
    }
  },
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    /** 索引值 用於更新數據 */
    index: Number,
    /** 包含數據源 */
    item: Object,
    disabled: {
      type: Boolean,
      default: false
    }
  },

  mounted() {
    /** 如果有值以傳入值為主 如果無值 已預設值為主 */
    this.dataValue = this.value
  },

  methods: {
    // 輸入的值
    valueChange(val, planList = []) {
      const data = {
        index: this.index,
        value: val
      }
      if (planList.length > 0) {
        data.plan = planList.filter(item => {
          return item.plan_id == this.dataValue
        })[0]
      }
      this.$emit('value-change', data)
    }
  }

}
